export default __webpack_public_path__ + "static/media/back.7f91b29e.jpg";